import React from 'react';
import { Slider } from 'baseui/slider';
import { SLIDER_OVERRIDES } from './overrides';
type PropsT = {
  maxFrames: number;
  sliderValue: [number];
  isDisabled: boolean;
  handleSliderChange: ({
    value: [number]
  }) => void;
  handleSliderFinal: ({
    value: [number]
  }) => void;
};
function _FrameSlider({
  maxFrames,
  sliderValue,
  isDisabled,
  handleSliderChange,
  handleSliderFinal
}: PropsT) {
  return <Slider min={0} max={maxFrames - 1} value={sliderValue} disabled={isDisabled} onChange={handleSliderChange} onFinalChange={handleSliderFinal} overrides={SLIDER_OVERRIDES} />;
}
export const FrameSlider = React.memo(_FrameSlider);